import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { DialogsRenderer } from '@theneatcompany/nui'
import CookieConsent from '@paper-monster/web/src/components/CookieConsent'
import RecaptchaTerms from '@paper-monster/web/src/components/common/RecaptchaTerms'
import { useSiteConfig } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'

import Seo from '@/components/layout/Seo'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer/Footer'
import ScrollToTopButton from '@/components/layout/ScrollToTopButton'

import styles from './Layout.module.scss'

const Layout = ({
  children,
  noNavFooter = false,
  showFooter = true,
  shouldRobotsIndex = true,
  showHeader = true,
  standalone = false,
  logoOnlyHeader = false,
  pageId,
}) => {
  const { links } = useSiteConfig()

  useEffect(() => {
    let didAdd = false

    if (standalone || (!showHeader && !showFooter)) {
      document.querySelector('body')?.classList.add('standalone-layout')
      didAdd = true
    }

    return () => {
      if (didAdd) {
        document.querySelector('body')?.classList.remove('standalone-layout')
      }
    }
  }, [standalone, showHeader, showFooter])

  const shouldRenderFooter = !standalone && showFooter

  return (
    <>
      <Seo pageId={pageId} shouldRobotsIndex={shouldRobotsIndex} />
      {!standalone && showHeader && <Header logoOnly={logoOnlyHeader} />}
      {children}
      <CookieConsent privacyHref={links.privacy} />
      <ScrollToTopButton />
      {shouldRenderFooter && <Footer hideNav={noNavFooter} />}
      {!shouldRenderFooter && pageId !== 'signUp' && <RecaptchaTerms textProps={{ center: true }} />}
      <DialogsRenderer />
    </>
  )
}

const Content = ({
  children,
  className,
  padded = false,
  topBorder = false,
  standalone = false,
}) => (
  <main className={cx(
    styles.content,
    padded && styles.padded,
    topBorder && styles.topBorder,
    standalone && styles.standalone,
    className,
  )}
  >
    {children}
  </main>
)

Layout.Content = Content

Layout.propTypes = {
  children: PropTypes.node,
  noNavFooter: PropTypes.bool,
  pageId: PropTypes.string,
  showFooter: PropTypes.bool,
  showHeader: PropTypes.bool,
  shouldRobotsIndex: PropTypes.bool,
  logoOnlyHeader: PropTypes.bool,
  standalone: PropTypes.bool,
}

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  padded: PropTypes.bool,
  topBorder: PropTypes.bool,
  standalone: PropTypes.bool,
}

export default Layout
